import React, { Component } from 'react';
import { Container, Row, Col, ListGroup, ListGroupItem, Button, Modal, ModalHeader, ModalBody, ModalFooter } from 'reactstrap';

import texts from '../../data/texts';
import quellen from '../../data/quellen';

class Quellen extends Component {
  render(){
    return (
      <Modal isOpen={this.props.isOpen} toggle={this.props.toggle} fade={false} size="lg" className="modal-dialog-centered border-0">
        <ModalBody className="bg-light pt-5 px-0 px-md-3">
          <Button color="link" onClick={this.props.toggle} style={{ position: 'absolute', top: 10, right: 10, zIndex: 1000 }}>
            <i className="fas fa-times" style={{ color: '#c8c8c8' }}></i>
          </Button>
          <Container>
            <div className="text-center pb-5">
              <img src='/imgs/paul_logo_color_small.svg' style={{width: '80px', height: 'auto'}} className='mb-4' />
              <h2 className="mb-2">{ texts.quellen_modal.headline }</h2>
              <h5>{ texts.quellen_modal.subline }</h5>
            </div>
            <Row>
              { quellen.map(category =>
                <Col xs="12" md="4" className="pb-5">
                  <h6 className="text-center mb-3">{category.name}</h6>
                  <ListGroup className="quellenModalListe shadow-sm">
                    { category.items.map(item =>
                      <ListGroupItem className="px-3 py-1">
                        <small className="d-flex justify-content-start align-items-center">
                          <i className="fas fa-university mr-3 text-secondary"></i>
                          <span>{item}</span>
                        </small>
                      </ListGroupItem> ) }
                  </ListGroup>
                </Col>
              ) }
            </Row>
          </Container>
        </ModalBody>
        <ModalFooter>
          <Button color="secondary" outline onClick={this.props.toggle}>{ texts.quellen_modal.close }</Button>
        </ModalFooter>
      </Modal>
    );
  }
}

export default Quellen;



// WEBPACK FOOTER //
// ./src/components/modals/QuellenModal.js